import {ThemeProvider} from '@emotion/react';
import React from 'react';

const theme = {
  borderRadii: {
    'default': '4px',
    'double': '8px',
  },
  colors: {
    dark: '#6c6c6c',
    darkest: '#2f2e31',
    light: '#a0a0a0',
    nearBlack: '#111',
    neutral: '#b6b6b6',
  },
  visuallyHidden: {
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(100%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: 1,
  },
};

export const Theme = ({children}) => <ThemeProvider theme={theme}>{children}</ThemeProvider>;
